import Insurer, { isInsurer } from "../types/Entities/Insurer";

export const getCaseReferenceNumberRegEx = (insurer: Insurer | string) => {
  if (isInsurer(insurer)) {
    insurer = "/insurers/" + insurer.id;
  }
  switch (insurer) {
    case "/insurers/2" /* Advocard */:
      return "^\\d{2}-?(33-?0001-?|\\d)\\d{5}-?\\d$";
    case "/insurers/6" /* ARAG */:
      return "^3100\\d{10}";
    default:
      return "^[a-zA-Z0-9-]{4,30}";
  }
};

export const getInsurerNumberRegEx = (insurer: Insurer | string) => {
  if (isInsurer(insurer)) {
    insurer = "/insurers/" + insurer.id;
  }
  switch (insurer) {
    case "/insurers/2" /* Advocard */:
      return "^(\\d{2}\\.?)?(\\d\\.?\\d{3}\\.?\\d{3}\\.?\\d)(\\-?\\d{2})?$";
    default:
      return ".*";
  }
};
